export default "__VITE_ASSET__F$qmGG8R__"